export default "__VITE_ASSET__DQJXoKbN__"